<template>
    <el-select v-model="val" @change="handleChange" placeholder="请选择语言">
        <el-option v-for="item in options" :key="item.id" :label="item.languageName" :value="item.id"> </el-option>
    </el-select>
</template>

<script>
import { list } from "@/api/language";
export default {
    props: {
        value: {
            type: Number | String,
            default: "",
        },
    },
    data() {
        return {
            val: "",
            options: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        search() {
            list().then(({ code, data, message }) => {
                if (code == 200) {
                    this.options = data;
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleChange(val) {
            this.$emit("input", val);
            this.$emit("change", val);
        },
    },
};
</script>

<style></style>
